<template>
    <div class="hashrate-conf">
        <el-form label-width="200px" :model="hashRateConfig" :rules="rules" ref="currencyForm"
                 style="width: 800px;background-color: white;margin: auto">
            <el-form-item label="显示数据：" prop="realData" style="padding-top: 20px">
                <el-radio-group v-model="hashRateConfig.realData">
                    <el-radio v-for="item in checkData" :label="item.value" :key="item.value">{{item.lable}}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="全网解锁奖励：" prop="allUnlock">
                <el-input v-model="hashRateConfig.allUnlock" placeholder="全网解锁奖励" style="width: 300px">
                    <i slot="suffix">FIL</i>
                </el-input>
                <span style="padding-left: 20px">0<=X<=99999999.99,支持8位小数</span>
            </el-form-item>
            <el-form-item label="当前云虎矿池奖励占比：" prop="yunHuProportion">
                <el-input v-model="hashRateConfig.yunHuProportion" placeholder="全网解锁奖励" style="width: 300px">
                    <i slot="suffix">%</i>
                </el-input>
                <span style="padding-left: 20px">0<=X<=100,支持4位小数</span>
            </el-form-item>
            <el-form-item label="当前云虎矿池奖励预估：" prop="yunHuRewardEstimate">
                <el-input v-model="hashRateConfig.yunHuRewardEstimate" placeholder="全网解锁奖励" style="width: 300px">
                    <i slot="suffix">FIL</i>
                </el-input>
                <span style="padding-left: 20px">0<=X<=99999999.99,支持8位小数</span>
            </el-form-item>
            <el-form-item label="预估产量：" prop="estimatedOutput">
                <el-input v-model="hashRateConfig.estimatedOutput" placeholder="全网解锁奖励" style="width: 300px">
                    <i slot="suffix">FIL/TB</i>
                </el-input>
                <span style="padding-left: 20px">0<=X<=99999999.99,支持8位小数</span>
            </el-form-item>
            <el-form-item label="最新FIL价格：" prop="newestPrice">
                <el-input v-model="hashRateConfig.newestPrice" style="width: 300px"/>
                <span style="padding-left: 20px">0<=X<=99999999.99,支持8位小数</span>
            </el-form-item>
            <el-form-item style="text-align: center;padding-bottom: 20px">
                <el-button type="primary" @click="handleSave('currencyForm')" style="margin: auto">保存</el-button>
            </el-form-item>

        </el-form>
    </div>
</template>

<script>
    import "./store";
    import api from "./api";

    export default {
        name: "hashRateConfig",
        data() {
            return {
                hashRateConfig: {}, //配置数据
                checkData: [{lable: "预计数据", value: false}, {lable: "结果数据", value: true}],
                rules: {
                    "allUnlock": [{required: true, message: "请输入数据"}],
                    "yunHuProportion": [{required: true, message: "请输入数据"}],
                    "yunHuRewardEstimate": [{required: true, message: "请输入数据"}],
                    "estimatedOutput": [{required: true, message: "请输入数据"}],
                    "newestPrice": [{required: true, message: "请输入数据"}],
                }
            };
        },
        created() {
            this.hashrateConfig();
        },
        methods: {
            hashrateConfig() {
                api.hashrateConfig().then(({data}) => {
                    this.hashRateConfig = data;
                });
            },
            handleSave(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.$confirm('确认修改吗？', '提示', {
                            type: 'warning'
                        }).then(() => {
                            api.updateHashrateConfig(this.hashRateConfig).then(({data}) => {
                                this.$message.success('修改成功！');
                                this.hashrateConfig();
                            });
                        }).catch(() => {
                        });
                    }
                });
            }
        }
    };
</script>

<style lang="less">
    .hashrate-conf {

    }
</style>
